module.exports = __webpack_public_path__ + "img/ae.7847726d.svg";